
// TODO: Move to tsutils


/**
 * Generic function to download a file
 * @param content The content
 * @param fileName The name of the file
 * @param mimetype The type of file
 */
export function downloadFile(content, fileName, mimetype){

    return new Promise(((resolve, reject) => {

        // Create a blob
        const blob = new Blob([content], {type: mimetype});

        // Use the msSaveOrOpenBlob if available
        if (window.navigator && window.navigator.msSaveOrOpenBlob) {
            console.log("Using msSaveOrOpenBlob");
            window.navigator.msSaveOrOpenBlob(blob)
            return;
        }

        // Create an <a> element and click it
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();

        // Remove the element created
        setTimeout(function () {
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
            resolve();
        }, 100);

    }));

}

/**
 * Download a PDF file
 * @param content Response data
 * @param fileNameByDefault The name of the file by defaylt
 */
export function downloadPDFWithDynamicName(content, fileNameByDefault){
    const headerContentDisp = content.headers["content-disposition"];
    const filename = headerContentDisp && headerContentDisp.split("filename=")[1].replace(/["']/g, "") || fileNameByDefault;
    return downloadFile(content.data, filename, 'application/pdf');
}

/**
 * Download a PDF file
 * @param content The content
 * @param fileName The name of the file
 */
export function downloadPDF(content, fileName){
    return downloadFile(content, fileName, 'application/pdf');
}

/**
 * Download a ZIP file
 * @param content The content
 * @param fileName The name of the file
 */
export function downloadZIP(content, fileName){
    return downloadFile(content, fileName, 'application/zip');
}

/**
 * Download a EXCEL file
 * @param content The content
 * @param fileName The name of the file
 */
export function downloadExcel(content, fileName){
    return downloadFile(content, fileName, 'application/vnd.ms-excel');
}

/**
 * Download a EXCEL file
 * @param content The response
 * @param fileNameByDefault The name of the file if we dont receive any name
 */
export function downloadExcelWithDynamicName(content, fileNameByDefault){
    const headerContentDisp = content.headers["content-disposition"];
    const filename = headerContentDisp && headerContentDisp.split("filename=")[1].replace(/["']/g, "") || fileNameByDefault;
    return downloadExcel(content.data, filename);
}